import React from "react";
import "./css/Mission.css";

export default function MissionSection() {
  return (
    <section className="mission-container">
      <h2 className="mission-title">आमचे ध्येय</h2>

      <h3 className="mission-subtitle">
“सर्वांसाठी समान संधी, स्वच्छता, शिक्षण आणि आत्मनिर्भरतेचे आदर्श गाव घडवणे.”      </h3>

      <p className="mission-text">
ग्रामपंचायत, नागरिक आणि विविध शासन योजनांच्या मदतीने आम्ही गावातील रस्ते, पाणीपुरवठा, आरोग्यसेवा, स्वच्छता व डिजिटल सुविधा यांचा सातत्याने विकास करत आहोत.
      </p>
    </section>
  );
}
